module.exports = __webpack_public_path__ + "static/Typold-Bold-6cd06115f95b061815089c1a0a95ec68.ttf";